import axios from "axios";
import { PLATFORM, CAPABILITIES } from "@/config/platform";
import { ILLUSTRATIVE_PLANS } from "@/config/plans";

const http = axios.create({ timeout: 12000, withCredentials: true });
const wait = (ms) => new Promise((r) => setTimeout(r, ms));
const demoRef = (p) => `DEMO-${p}-${Date.now().toString(36).toUpperCase().slice(-6)}`;

export const isLive = (cap) => Boolean(PLATFORM.apiBaseUrl && CAPABILITIES[cap]?.verified && CAPABILITIES[cap]?.endpoint);

export const newIdempotencyKey = () =>
  (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);

function errorMessage(e) {
  if (e.code === "ECONNABORTED") return "The platform did not respond in time. Please try again.";
  const d = e.response?.data?.detail;
  if (typeof d === "string") return d;
  return "The platform could not accept this request.";
}

async function call(cap, payload, idempotencyKey, prefix) {
  if (!isLive(cap)) {
    await wait(700);
    return { mode: "demo", reference: demoRef(prefix) };
  }
  const { endpoint, method = "post" } = CAPABILITIES[cap];
  try {
    const res = await http.request({ url: PLATFORM.apiBaseUrl + endpoint, method, data: payload, headers: { "Idempotency-Key": idempotencyKey } });
    return { mode: "live", reference: res.data?.reference ?? null, data: res.data };
  } catch (e) {
    throw new Error(errorMessage(e));
  }
}

export const provisionTenant = (payload, key) => call("tenantProvisioning", payload, key, "ONB");
export const submitInquiry = (payload, key) => call("publicInquiry", payload, key, "INQ");
export const registerPartner = (payload, key) => call("partnerRegistration", payload, key, "PRT");

export async function fetchPlans() {
  if (!isLive("plans")) return { mode: "demo", plans: ILLUSTRATIVE_PLANS };
  const res = await http.get(PLATFORM.apiBaseUrl + CAPABILITIES.plans.endpoint);
  return { mode: "live", plans: res.data?.plans || [] };
}
